import React from 'react';
import { SmlsModal, SmlsButton } from '@smiles/smiles-ui-kit-react';
import { useTranslation } from 'react-i18next';

import { SkipUploadFilesModalProps } from './types';

const SkipUploadFilesModal = ({
  isOpen = false,
  isLoading,
  onConfirmation,
  toggleModal,
}: SkipUploadFilesModalProps) => {
  const { t } = useTranslation('skip_upload_files');

  return (
    <SmlsModal isOpen={isOpen} defaultHeader className="suspended-user-modal" type="right" toggle={toggleModal}>
      <div className="default-modal-message">
        <h4>{t('title')}</h4>
        <p>{t('subtitle')}</p>
        <SmlsButton
          text={t('submit_button')}
          color="primary"
          type="button"
          disabled={false}
          onClick={() => onConfirmation(false)}
        />
        <SmlsButton
          text={t('skip_button')}
          color="hyperlink"
          type="button"
          disabled={isLoading}
          isLoading={isLoading}
          onClick={() => {
            onConfirmation(true);
          }}
        />
      </div>
    </SmlsModal>
  );
};

export default SkipUploadFilesModal;
